import { useSiteContext } from '@eti/providers';
import { useEffect } from 'react';
import { analytics } from '@eti/utils';
import type { Currency } from '@eti/schema-types';
import type {
  AncillaryBundle,
  Bound,
  Product,
  TravelerPrice,
} from '../../../../pages/traveler-details/models';
import { formatPrice, getAirProduct } from '../utils';

const getBundles = (bundles: AncillaryBundle[], siteCurrency: Currency) => {
  if (!bundles) {
    return [];
  }
  return bundles?.map((bundle) => ({
    name: bundle.title,
    id: `BUNDLE-${bundle.id}`,
    price: formatPrice(siteCurrency.exponent, bundle.price).toString(),
    quantity: 1,
  }));
};
const getProducts = (products: Product[], siteCurrency: Currency) => {
  if (!products) {
    return [];
  }
  return products?.map((product) => {
    return {
      name: product.title,
      id: `PRODUCT-${product.id}`,
      price: formatPrice(siteCurrency.exponent, product.price).toString(),
      quantity: 1,
    };
  });
};
const getDiscountPrice = (discountPrice: number, siteCurrency: Currency) => {
  if (!discountPrice) {
    return [];
  }

  return [
    {
      name: 'DISCOUNT',
      id: 'DISCOUNT',
      price: formatPrice(siteCurrency.exponent, discountPrice).toString(),
      quantity: 1,
    },
  ];
};
export const useEcommerceDataLayerEffect = (
  bounds: Bound[],
  bundles: AncillaryBundle[],
  discountPrice: number,
  cartId: number,
  extraProducts: Product[],
  travelerPrices: TravelerPrice[],
) => {
  const { siteCurrency, siteName } = useSiteContext();
  useEffect(() => {
    analytics.pushEntryToDataLayer({ ecommerce: null }, false);
    const event = {
      ecommerce: {
        purchase: {
          actionField: {
            id: parseInt(cartId?.toString(), 36).toString(),
            affiliation: siteName,
            revenue: '0',
            tax: '0',
            shipping: '0',
          },
          products: [
            getAirProduct(travelerPrices, siteCurrency?.currencyExponent),
            ...getBundles(bundles, siteCurrency),
            ...getProducts(extraProducts, siteCurrency),
            ...getDiscountPrice(discountPrice, siteCurrency),
          ],
        },
      },
    };
    analytics.pushEntryToDataLayer(event, false);
  }, [
    bounds,
    bundles,
    cartId,
    discountPrice,
    extraProducts,
    siteCurrency,
    siteName,
    travelerPrices,
  ]);
};
